import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { UseWalletProvider } from 'use-wallet';

import Routing from './Routing';
import { Language, Theme, Web3Provider } from './contexts';
import Network from './contexts/Network';
import { OffchainProvider } from './contexts/OffchainProvider';
import { OnchainProvider } from './contexts/OnchainProvider';
import { useChainId } from './hooks/useNetwork';
import './index.scss';
import store from './state';
import Updaters from './state/Updaters';

const root = document.getElementById('root');
const Contexts = ({ children }) => {
    const chainId = useChainId();
    return (
        <Provider store={store}>
            <Network>
                <Language>
                    <Theme>
                        <UseWalletProvider chainId={chainId}>
                            <Web3Provider>
                                <Updaters />
                                <OffchainProvider>
                                    <OnchainProvider>{children}</OnchainProvider>
                                </OffchainProvider>
                            </Web3Provider>
                        </UseWalletProvider>
                    </Theme>
                </Language>
            </Network>
        </Provider>
    );
};

if (root) {
    const app = createRoot(root);

    app.render(
        <div className="app">
            <Contexts>
                <Routing />
            </Contexts>
        </div>
    );
}
